import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';

export default function InstagramFeed() {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  const instagramPosts = [
    {
      id: 1,
      url: 'https://www.instagram.com/p/Cndtj0aI9fh/'
    },
    {
      id: 2,
      url: 'https://www.instagram.com/p/Cnl3j8vIZNo/'
    },
    {
      id: 3,
      url: 'https://www.instagram.com/p/CnoKQiMIWzP/'
    }
  ];

  useEffect(() => {
    // Instagram埋め込みスクリプトを読み込む
    const script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;
    document.body.appendChild(script);

    // スクリプトが読み込まれた後、埋め込みを処理
    script.onload = () => {
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section ref={ref} className="py-16 px-5 bg-[#000000]">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
        className="text-center mb-8"
      >
        <p className="text-[#e1306c] text-xs tracking-[0.3em] uppercase mb-2">
          FOLLOW US
        </p>
        <h2 className="text-white text-2xl font-medium mb-4">@3dcars_official</h2>
        <div className="w-8 h-8 mx-auto rounded-full bg-gradient-to-br from-[#f09433] via-[#e1306c] to-[#c13584] flex items-center justify-center">
          <i className="ri-instagram-fill text-white text-xl"></i>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ delay: 0.3 }}
        className="max-w-4xl mx-auto mb-8"
      >
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {instagramPosts.map((post, index) => (
            <motion.div
              key={post.id}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ delay: 0.1 * index }}
              className="aspect-square overflow-hidden rounded-lg"
            >
              <blockquote
                className="instagram-media"
                data-instgrm-captioned
                data-instgrm-permalink={post.url}
                data-instgrm-version="14"
                style={{
                  background: '#000',
                  border: 0,
                  borderRadius: '8px',
                  boxShadow: 'none',
                  margin: 0,
                  padding: 0,
                  width: '100%',
                  height: '100%'
                }}
              >
                <a href={post.url} target="_blank" rel="noopener noreferrer">
                  View this post on Instagram
                </a>
              </blockquote>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <div className="text-center">
        <a
          href="https://www.instagram.com/3dcars_official/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-3 border border-[#e1306c] text-[#e1306c] rounded-full text-sm font-medium hover:bg-[#e1306c] hover:text-white transition-all cursor-pointer whitespace-nowrap"
        >
          View on Instagram
        </a>
      </div>

      <style>{`
        .instagram-media {
          min-width: 100% !important;
          max-width: 100% !important;
        }
        
        /* ヘッダー（ロゴ、ユーザー名）を非表示 */
        .instagram-media iframe {
          pointer-events: none;
        }
        
        /* Instagram埋め込みのパディングを削除 */
        .instagram-media > div {
          padding: 0 !important;
        }
        
        /* キャプションとフッター（いいね、コメント）を非表示 */
        .instagram-media::after {
          display: none !important;
        }
      `}</style>
    </section>
  );
}

declare global {
  interface Window {
    instgrm?: {
      Embeds: {
        process: () => void;
      };
    };
  }
}